import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tgg_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors (skip login endpoint — 401 there means bad credentials)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('tgg_token');
      localStorage.removeItem('tgg_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.put('/auth/profile', data)
};

export const crmAPI = {
  getStores: () => api.get('/crm/stores'),
  getStoresStats: () => api.get('/crm/stores/stats'),
  saveApiKey: (key) => api.post('/crm/api-key', { apiKey: key }),
  getApiKey: () => api.get('/crm/api-key')
};

export const dataAPI = {
  getWhatsAppGroups: () => api.get('/data/whatsapp-groups'),
  updateWhatsAppGroups: (groups) => api.put('/data/whatsapp-groups', { groups }),
  getMarketing: () => api.get('/data/marketing'),
  saveMarketing: (data) => api.put('/data/marketing', data),
  getContent: () => api.get('/data/content'),
  saveContent: (content) => api.put('/data/content', { content }),
  getTransformations: () => api.get('/data/transformations'),
  createTransformation: (data) => api.post('/data/transformations', data),
  updateTransformation: (id, data) => api.put(`/data/transformations/${id}`, data),
  deleteTransformation: (id) => api.delete(`/data/transformations/${id}`),
  getRelances: () => api.get('/data/relances'),
  saveRelances: (relances) => api.put('/data/relances', { relances }),
  getAbsences: () => api.get('/data/absences'),
  saveAbsences: (absences) => api.put('/data/absences', { absences })
};

export const marketingAPI = {
  getAll: () => api.get('/marketing'),
  create: (data) => api.post('/marketing', data),
  update: (id, data) => api.put(`/marketing/${id}`, data),
  delete: (id) => api.delete(`/marketing/${id}`)
};

export const relancesAPI = {
  getAll: (params) => api.get('/relances', { params }),
  create: (data) => api.post('/relances', data),
  update: (id, data) => api.put(`/relances/${id}`, data),
  delete: (id) => api.delete(`/relances/${id}`),
  importFile: (file, year) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('year', year);
    return api.post('/import/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export default api;
